(function ($) {

    $(document).ready(function () {
        $('.osm-map.populate').each( (index, element) => {
            const $osmMap = $(element);
            const $markerPopUps = $osmMap.find(".marker");
            const openStreetMapVO = createDefaultOpenStreetVO($osmMap, $markerPopUps);

            const openStreetMapFunctions = createOpenStreetMap(openStreetMapVO);
            $osmMap.data('open-street-map-functions', openStreetMapFunctions);
        });
        $('.reveal-map').each((index, btn) => {
            const $btn = $(btn);
            const revealID = $btn.data('reveal-id');
            const $maps = revealID ? $("#"+revealID+" .osm-map.populate") : $();
            if($maps.length){
                $btn.on("click tap touchstart",  (e) => {
                    $maps.css({opacity: 0})
                    setTimeout(() => {
                        $maps.animate({opacity: 1})
                        $maps.each((index, map) => {
                            const $map = $(map);
                            /** @type {OpenStreetMapFunctions} */
                            const openStreetMapFunctions = $map.data('open-street-map-functions');
                            if(openStreetMapFunctions){
                                openStreetMapFunctions.onShowMapClicked(true);
                            }
                        })
                    }, 200)
                });
            }
        })
    });
})(jQuery);